(function (Drupal, once) {
  'use strict';

  // Create or extend shared namespace
  window.McmnExperience = window.McmnExperience || {};
  const Mcmn = window.McmnExperience;

  /**
   * Initialize Chapter 4 (Reyes) interactions
   */
  function initChapter4(svgContainer, svg, chapterState, sectionType) {
    // Initialize chapter state (like Chapter 1)
    if (!chapterState.placedGrass) {
      chapterState.placedGrass = new Set();
    } else if (!(chapterState.placedGrass instanceof Set)) {
      chapterState.placedGrass = new Set(chapterState.placedGrass);
    }
    if (!chapterState.grassPositions) {
      chapterState.grassPositions = {};
    }
    
    // Get SVG elements
    //const stars = svg.querySelector('#stars');
    const grassGroup = svg.querySelector('#grass');
    const box = svg.querySelector('#box');
    const boxLanding = svg.querySelector('#box-landing');
    const coqui = svg.querySelector('#coqui');
    const playButton = svg.querySelector('#play-button');
    const grassSnippet = svg.querySelector('#grass-snippet');

    if (!grassGroup || !box || !boxLanding || !coqui) {
      return;
    }

    // Hide hotspot immediately
    const hotspot = svg.querySelector('#hotspot');
    if (hotspot) {
      hotspot.style.visibility = 'hidden';
      hotspot.style.display = 'none';
      hotspot.style.opacity = '0';
      hotspot.style.pointerEvents = 'none';
    }

    // Hide grass-snippet immediately (box starts empty)
    // Note: We'll get its bbox in initGrassDragDrop before fully hiding it
    if (grassSnippet) {
      grassSnippet.style.visibility = 'hidden';
      grassSnippet.style.display = 'none';
      grassSnippet.style.opacity = '0';
    }

    // Initialize star flickering
    // if (Mcmn.initStarBlinking) {
    //   Mcmn.initStarBlinking(stars);
    // }

    // Initialize grass drag and drop
    initGrassDragDrop(svgContainer, svg, grassGroup, box, boxLanding, chapterState, sectionType);

    // Initialize coqui audio
    initCoquiAudio(svgContainer, svg, coqui, playButton, chapterState, sectionType);
  }

  /**
   * Initialize grass drag and drop to box using SVG.js
   */
  function initGrassDragDrop(svgContainer, svg, grassGroup, box, boxLanding, chapterState, sectionType) {
    // Get message element (hotspot is hidden)
    const placeTheGrass = svg.querySelector('#place-the-grass');
    
    // Initialize SVG.js
    const svgJs = Mcmn.initSvgJs ? Mcmn.initSvgJs(svg) : null;
    if (!svgJs) {
      return;
    }
    
    // Wrap elements with SVG.js - use boxLanding for drop detection
    const grassGroupJs = grassGroup ? SVG.adopt(grassGroup) : null;
    const boxLandingJs = boxLanding ? SVG.adopt(boxLanding) : null;
    
    const grassElements = grassGroup ? grassGroup.querySelectorAll('path') : [];
    const grassSnippet = svg.querySelector('#grass-snippet');
    let dragElement = null;
    let currentGrassIndex = null;
    
    if (!grassGroup || grassElements.length === 0 || !boxLandingJs) {
      return;
    }
    
    // Ensure box-landing doesn't block interactions but is used for detection
    if (boxLanding) {
      boxLanding.style.pointerEvents = 'none'; // Don't block grass clicks
    }
    
    // Hotspot is already hidden, no need to check restored state
    
    // Ensure grass group and container allow pointer events
    if (grassGroup) {
      grassGroup.style.pointerEvents = 'auto';
      // Make sure all children also have pointer events
      const allChildren = grassGroup.querySelectorAll('*');
      allChildren.forEach(child => {
        child.style.pointerEvents = 'auto';
      });
    }
    if (svgContainer) {
      svgContainer.style.pointerEvents = 'auto';
      svgContainer.style.cursor = 'crosshair'; // Set crosshair cursor like Chapter 1
    }
    if (svg) {
      svg.style.pointerEvents = 'auto';
    }
    
    // Clean up any leftover drag elements from previous sessions (like Chapter 1)
    const leftoverDragElements = svg.querySelectorAll('[id*="drag-grass"]');
    leftoverDragElements.forEach(dragEl => {
      if (dragEl && dragEl.id && dragEl.id.includes('drag-grass')) {
        try {
          if (dragEl.parentNode) {
            dragEl.parentNode.removeChild(dragEl);
          }
        } catch (e) {
          // Cleanup error
        }
      }
    });
    
    // Ensure grass-snippet is hidden (in case restoreGrassPositions or something else showed it)
    if (grassSnippet) {
      grassSnippet.style.visibility = 'hidden';
      grassSnippet.style.display = 'none';
      grassSnippet.style.opacity = '0';
    }

    // Store grass-snippet's original bbox before hiding
    let grassSnippetOriginalBbox = null;
    if (grassSnippet) {
      // Temporarily show it to get accurate bbox
      const wasHidden = grassSnippet.style.visibility === 'hidden' || grassSnippet.style.display === 'none';
      if (wasHidden) {
        grassSnippet.style.visibility = 'visible';
        if (grassSnippet.style.display === 'none') {
          grassSnippet.style.display = '';
        }
      }
      
      // Get original bbox before any transforms using SVG.js
      const grassSnippetJs = SVG.adopt(grassSnippet);
      if (grassSnippetJs) {
        grassSnippetJs.transform({ x: 0, y: 0 }); // Reset to get original bbox
        grassSnippetOriginalBbox = grassSnippetJs.bbox();
      } else {
        gsap.set(grassSnippet, { x: 0, y: 0 });
        grassSnippetOriginalBbox = grassSnippet.getBBox();
      }
      
      // Hide the original grass-snippet (it will be cloned for dragging)
      // Use GSAP to ensure it stays hidden
      gsap.set(grassSnippet, {
        visibility: 'hidden',
        display: 'none',
        opacity: 0
      });
      grassSnippet.style.visibility = 'hidden';
      grassSnippet.style.display = 'none';
      grassSnippet.style.opacity = '0';
    }

    // Convert screen coordinates to SVG coordinates (same as Chapter 1 and 3)
    function screenToSVG(clientX, clientY) {
      // Use the actual SVG DOM element for accurate coordinate conversion
      const svgRect = svg.getBoundingClientRect();
      const svgPoint = svg.createSVGPoint();
      svgPoint.x = clientX;
      svgPoint.y = clientY;
      
      // Transform to SVG coordinate system
      const ctm = svg.getScreenCTM();
      if (ctm) {
        const inverseCTM = ctm.inverse();
        const transformedPoint = svgPoint.matrixTransform(inverseCTM);
        return { x: transformedPoint.x, y: transformedPoint.y };
      }
      
      // Fallback: simple calculation
      const viewBox = svg.viewBox.baseVal;
      const scaleX = viewBox.width / svgRect.width;
      const scaleY = viewBox.height / svgRect.height;
      
      return {
        x: (clientX - svgRect.left) * scaleX,
        y: (clientY - svgRect.top) * scaleY
      };
    }

    // Check if point is over box-landing (same robust checking as Chapter 1's isOverTree)
    function isOverBox(x, y) {
      if (!boxLanding) {
        return false;
      }
      
      const svgPoint = screenToSVG(x, y);
      
      // Create an SVG point in the SVG's coordinate system for boundary checking
      const point = svg.createSVGPoint();
      point.x = svgPoint.x;
      point.y = svgPoint.y;
      
      // Check if point is inside box-landing using isPointInFill (for polygon)
      let isInside = false;
      
      try {
        if (boxLanding.isPointInFill) {
          if (boxLanding.isPointInFill(point)) {
            isInside = true;
          }
        } else if (boxLanding.isPointInStroke) {
          // Fallback to stroke check if fill not available
          if (boxLanding.isPointInStroke(point)) {
            isInside = true;
          }
        } else {
          // Fallback to bbox check
          const bbox = boxLanding.getBBox();
          isInside = svgPoint.x >= bbox.x && 
                    svgPoint.x <= bbox.x + bbox.width &&
                    svgPoint.y >= bbox.y && 
                    svgPoint.y <= bbox.y + bbox.height;
        }
      } catch (e) {
        return false;
      }
      
      if (!isInside) {
        return false;
      }
      
      // Additional safety check: verify point is within box-landing bounding box
      const boxBbox = boxLanding.getBBox();
      const isWithinBbox = svgPoint.x >= boxBbox.x && 
                          svgPoint.x <= boxBbox.x + boxBbox.width &&
                          svgPoint.y >= boxBbox.y && 
                          svgPoint.y <= boxBbox.y + boxBbox.height;
      
      if (!isWithinBbox) {
        return false;
      }
      
      // Only return true if BOTH checks pass
      return true;
    }

    // Highlight the box-landing polygon itself instead of creating a circle
    function showBoxLandingHighlight() {
      if (!boxLanding) return;
      
      // Store original fill to restore later
      if (!boxLanding.dataset.originalFill) {
        boxLanding.dataset.originalFill = boxLanding.getAttribute('fill') || 'none';
      }
      
      // Highlight with semi-transparent fill
      boxLanding.setAttribute('fill', 'rgba(171, 10, 71, 0.3)');
      boxLanding.setAttribute('stroke', '#AB0A47');
      boxLanding.setAttribute('stroke-width', '3');
      
      // Pulse animation
      gsap.to(boxLanding, {
        opacity: 0.7,
        duration: 0.8,
        repeat: -1,
        yoyo: true,
        ease: 'power1.inOut'
      });
    }
    
    function hideBoxLandingHighlight() {
      if (!boxLanding) return;
      
      // Kill any animations
      gsap.killTweensOf(boxLanding);
      
      // Restore original fill
      if (boxLanding.dataset.originalFill) {
        boxLanding.setAttribute('fill', boxLanding.dataset.originalFill);
      }
      
      // Remove stroke
      boxLanding.removeAttribute('stroke');
      boxLanding.removeAttribute('stroke-width');
      
      // Reset opacity
      gsap.to(boxLanding, {
        opacity: 1,
        duration: 0.3
      });
    }

    // Place grass in box (at grass-snippet's original position)
    function placeGrassInBox(screenX, screenY) {
      if (currentGrassIndex === null || !grassSnippet) return;
      
      const grass = grassElements[currentGrassIndex];
      if (!grass) return;

      // CRITICAL: Double-check boundary BEFORE placing (like Chapter 1)
      const isOver = isOverBox(screenX, screenY);
      if (!isOver) {
        // Cancel drag and cleanup
        if (dragElement && dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
          dragElement = null;
        }
        cancelDrag();
        return;
      }
      
      // FINAL VALIDATION: Double-check the drop point is within box-landing
      const finalCheck = isOverBox(screenX, screenY);
      if (!finalCheck) {
        if (dragElement && dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
          dragElement = null;
        }
        cancelDrag();
        return;
      }

      // Calculate drop position in SVG coordinates (like Chapter 1 ornaments)
      const svgPoint = screenToSVG(screenX, screenY);
      
      // Get grass-snippet bbox for positioning
      const grassSnippetJs = SVG.adopt(grassSnippet);
      if (!grassSnippetJs) {
        cancelDrag();
        return;
      }
    
      // Reset transforms to get original bbox
      grassSnippetJs.transform({ x: 0, y: 0, scale: 1 });
      const grassBbox = grassSnippetJs.bbox();
      
      // Get box-landing bounds to constrain placement
      const boxBbox = boxLanding.getBBox();
      
      // Calculate position to center the grass-snippet at cursor
      let dropX = svgPoint.x - (grassBbox.width / 2);
      let dropY = svgPoint.y - (grassBbox.height / 2);
      
      // Constrain grass to stay within box-landing bounds
      // Ensure left edge doesn't go past box left edge
      dropX = Math.max(boxBbox.x, dropX);
      // Ensure right edge doesn't go past box right edge
      dropX = Math.min(boxBbox.x + boxBbox.width - grassBbox.width, dropX);
      // Ensure top edge doesn't go past box top edge
      dropY = Math.max(boxBbox.y, dropY);
      // Ensure bottom edge doesn't go past box bottom edge
      dropY = Math.min(boxBbox.y + boxBbox.height - grassBbox.height, dropY);

      // Create a new grass-snippet clone to place in the box
      const placedGrass = grassSnippet.cloneNode(true);
      // Use timestamp to allow multiple placements of same grass
      placedGrass.id = 'placed-grass-' + currentGrassIndex + '-' + Date.now();
      placedGrass.style.opacity = '1';
      placedGrass.style.visibility = 'visible';
      placedGrass.style.display = 'block';
      // Temporary fix for keeping leaves in the center of the box. - Aaron 
      placedGrass.style.transform = 'translate(0px, 0px)';

      // Move placed grass to box group first
      box.appendChild(placedGrass);
      
      // Wrap with SVG.js for positioning
      const placedGrassJs = SVG.adopt(placedGrass);
      if (placedGrassJs) {
        // Position it at the drop location using SVG.js
        placedGrassJs.move(dropX, dropY);
        placedGrassJs.scale(1);
        placedGrassJs.opacity(0);
        
        // Animate it in
      gsap.fromTo(placedGrass, 
          { opacity: 0, scale: 0 },
        { 
          opacity: 1, 
          scale: 1,
            duration: 0.3,
            ease: 'back.out(1.7)',
            transformOrigin: 'center center',
            onComplete: function() {
              // Ensure final position using SVG.js
              placedGrassJs.move(dropX, dropY);
              placedGrassJs.scale(1);
              placedGrassJs.opacity(1);
            }
          }
        );
      } else {
        // Fallback to GSAP only
        gsap.fromTo(placedGrass, 
          { opacity: 0, scale: 0, x: dropX, y: dropY },
          { 
            opacity: 1, 
            scale: 1,
            x: dropX,
            y: dropY,
          duration: 0.3,
          ease: 'back.out(1.7)',
          transformOrigin: 'center center'
        }
      );
      }

      // Keep original grass visible and interactive for continuous grabbing
      // Don't disable pointer events so user can grab again
      
      // Save state with actual drop position - store array of positions for multiple placements
      chapterState.placedGrass.add(currentGrassIndex);
      if (!chapterState.grassPositions[currentGrassIndex]) {
        chapterState.grassPositions[currentGrassIndex] = [];
      }
      chapterState.grassPositions[currentGrassIndex].push({ x: dropX, y: dropY });
      if (Mcmn.saveChapterState) {
        Mcmn.saveChapterState(sectionType, chapterState);
      }
      
      // Mark grass grab as complete when first grass piece is placed
      if (chapterState.placedGrass.size === 1 && Mcmn.CookieManager && Mcmn.CookieManager.markHotspotComplete) {
        Mcmn.CookieManager.markHotspotComplete(sectionType, 'grass-grab');
        // Check completion after marking hotspot
        if (Mcmn.checkCompletion) {
          const viewedSections = new Set(Mcmn.CookieManager.getViewedSections());
          Mcmn.checkCompletion(viewedSections);
        }
      }
      
      // Show download button after first grass is placed
      checkAndShowDownloadButton();
      
      // IMMEDIATELY remove drag element after successful placement (like Chapter 1)
      if (dragElement) {
        if (dragElement.node && dragElement.node.parentNode) {
            dragElement.remove();
          }
        dragElement = null;
      }
      
      // Event listeners already removed in handleClick before calling this function
      
      // Hide box-landing highlight
      hideBoxLandingHighlight();
      
      // Reset state
      currentGrassIndex = null;
      svgContainer.style.cursor = 'crosshair';
    }

    // Restore grass positions
    function restoreGrassPositions() {
      if (!grassSnippet) return;
      
      // Get box-landing bounds for constraining restored positions
      const boxBbox = boxLanding ? boxLanding.getBBox() : null;

      grassElements.forEach((grass, index) => {
        if (chapterState.placedGrass.has(index)) {
          const positions = chapterState.grassPositions[index];
          if (positions) {
            // Handle both old format (single object) and new format (array)
            const posArray = Array.isArray(positions) ? positions : [positions];
            
            // Get grass bbox for constraint calculations
            const grassSnippetJs = SVG.adopt(grassSnippet);
            const grassBbox = grassSnippetJs ? grassSnippetJs.bbox() : null;
            
            // Restore each placement
            posArray.forEach((pos, posIndex) => {
              // Constrain position to box bounds (in case box changed or old positions were outside)
              let constrainedX = pos.x;
              let constrainedY = pos.y;
              
              if (boxBbox && grassBbox) {
                constrainedX = Math.max(boxBbox.x, Math.min(boxBbox.x + boxBbox.width - grassBbox.width, pos.x));
                constrainedY = Math.max(boxBbox.y, Math.min(boxBbox.y + boxBbox.height - grassBbox.height, pos.y));
              }
              
              // Create a new grass-snippet clone to place in the box
              const placedGrass = grassSnippet.cloneNode(true);
              placedGrass.id = 'placed-grass-' + index + '-restored-' + posIndex;
              placedGrass.style.opacity = '1';
              placedGrass.style.visibility = 'visible';
              placedGrass.style.display = 'block';

              box.appendChild(placedGrass);
              
              // Position using SVG.js (like Chapter 1)
              const placedGrassJs = SVG.adopt(placedGrass);
              if (placedGrassJs) {
                placedGrassJs.move(constrainedX, constrainedY);
                placedGrassJs.scale(1);
                placedGrassJs.opacity(1);
              } else {
                // Fallback to GSAP
                gsap.set(placedGrass, {
                  x: constrainedX,
                  y: constrainedY,
                  transformOrigin: 'center center'
                });
              }
            });

            // Keep original grass visible and interactive for continuous grabbing
            grass.style.pointerEvents = 'auto';
            grass.style.cursor = 'pointer';
          }
        }
      });
    }

    // Create drag element from grass-snippet using SVG.js
    function createDragGrass() {
      if (!grassSnippet) {
        return null;
      }
      
      const clone = grassSnippet.cloneNode(true);
      clone.id = 'drag-grass-snippet-' + Date.now();
      clone.style.pointerEvents = 'none';
      clone.style.visibility = 'visible';
      clone.style.opacity = '1';
      
      // Add to SVG at the end so it's on top (like Chapter 1)
      svg.appendChild(clone);
      
      // Move to top of rendering order
      if (clone.parentNode) {
        clone.parentNode.appendChild(clone);
      }
      
      // Wrap with SVG.js
      const cloneJs = SVG.adopt(clone);
      if (!cloneJs) return null;
      
      // Reset transforms and ensure visible (like Chapter 1)
      cloneJs.transform({ x: 0, y: 0, scale: 1 });
      cloneJs.opacity(1);
      cloneJs.show();
      cloneJs.scale(1);
      
      return cloneJs;
    }
    
    // Mouse/touch move handler to follow cursor with drag element (using SVG.js)
    function handleMouseMove(e) {
      if (!dragElement || currentGrassIndex === null || !grassSnippetOriginalBbox) {
        return;
      }
      
      // Prevent scrolling on touch devices
      if (e.type === 'touchmove') {
        e.preventDefault();
      }
      
      const coords = Mcmn.getEventCoordinates ? Mcmn.getEventCoordinates(e) : { clientX: e.clientX, clientY: e.clientY };
      const svgPoint = screenToSVG(coords.clientX, coords.clientY);
      
      // Position drag element at cursor - center it like ornaments
      const centerX = svgPoint.x - (grassSnippetOriginalBbox.width / 2);
      const centerY = svgPoint.y - (grassSnippetOriginalBbox.height / 2);
      
      dragElement.move(centerX, centerY);
      dragElement.scale(1);
      dragElement.opacity(1);
      dragElement.show();
      
      // Box-landing highlight is already showing and pulsing from when drag started
    }
    
    // Click/touch handler to place grass or cancel
    function handleClick(e) {
      const coords = Mcmn.getEventCoordinates ? Mcmn.getEventCoordinates(e) : { clientX: e.clientX, clientY: e.clientY };
      
      // Don't process if clicking on grass (but only for mouse events)
      // For touch events, the target is often the original element even if finger moved
      if (e.type !== 'touchend') {
        if (e.target.closest && (e.target.closest('#grass') || e.target.closest('path'))) {
          const clickedPath = e.target.closest('path');
          if (clickedPath && clickedPath.parentNode === grassGroup) {
            // If clicking on a different grass while dragging, cancel current and let new one start
            if (dragElement) {
              cancelDrag();
            }
            return; // Let the grass click handler handle it
          }
        }
      }
      
      if (!dragElement || currentGrassIndex === null) {
        return;
      }
      
      // Remove event listeners immediately (mouse and touch) (like Chapter 1)
      svgContainer.removeEventListener('mousemove', handleMouseMove);
      svgContainer.removeEventListener('touchmove', handleMouseMove);
      svgContainer.removeEventListener('click', handleClick);
      svgContainer.removeEventListener('click', handleClick, true);
      svgContainer.removeEventListener('touchend', handleClick);
      svgContainer.removeEventListener('touchend', handleClick, true);
      
      // STRICT: Only allow dropping on the box-landing (like Chapter 1's tree check)
      const isOver = isOverBox(coords.clientX, coords.clientY);
      
      if (!isOver) {
        // Cancel and cleanup
        if (dragElement && dragElement.node && dragElement.node.parentNode) {
          dragElement.remove();
          dragElement = null;
        }
        cancelDrag();
        return;
      }
      
      // Only place if over box-landing
      placeGrassInBox(coords.clientX, coords.clientY);
    }
    
    function cancelDrag() {
      // Remove event listeners (mouse and touch)
      svgContainer.removeEventListener('mousemove', handleMouseMove);
      svgContainer.removeEventListener('touchmove', handleMouseMove);
      svgContainer.removeEventListener('click', handleClick);
      svgContainer.removeEventListener('click', handleClick, true);
      svgContainer.removeEventListener('touchend', handleClick);
      svgContainer.removeEventListener('touchend', handleClick, true);
      
      // Don't need to restore grass appearance since we never changed it
      
      // IMMEDIATELY remove drag element (like Chapter 1) - don't animate, just remove
      if (dragElement) {
        if (dragElement.node && dragElement.node.parentNode) {
            dragElement.remove();
          }
        dragElement = null;
      }
      
      // Also check for any drag elements by ID pattern and remove them immediately (cleanup any orphans)
      const allDragElements = svg.querySelectorAll('[id*="drag-grass"]');
      allDragElements.forEach(dragEl => {
        if (dragEl && dragEl.parentNode && dragEl.id && dragEl.id.includes('drag-grass')) {
          try {
            dragEl.parentNode.removeChild(dragEl);
          } catch (e) {
            // Cleanup failed
            }
          }
        });
      
      // Hide box-landing highlight
      hideBoxLandingHighlight();
      
      // Reset state
      currentGrassIndex = null;
      svgContainer.style.cursor = 'crosshair';
    }


    // Initialize grass elements
    grassElements.forEach((grass, index) => {
      // Allow continuous grabbing - don't skip if already placed

      // Make grass clickable
      grass.style.cursor = 'pointer';
      grass.style.pointerEvents = 'auto';
      
      // No visual hover effect - grass stays as-is
      grass.addEventListener('mouseenter', function() {
        // Just change cursor, no visual change
      });

      grass.addEventListener('mouseleave', function() {
        // Just reset cursor, no visual change
      });

      // Click/touch to start drag (like clicking basket for ornaments)
      const grassClickHandler = function(e) {
        // Allow continuous grabbing - don't check if already placed

        e.preventDefault();
        e.stopPropagation();
        
        // Get coordinates (works for mouse and touch)
        const coords = Mcmn.getEventCoordinates ? Mcmn.getEventCoordinates(e) : { clientX: e.clientX, clientY: e.clientY };
        
        // Mark hotspot as complete
        if (Mcmn.CookieManager && Mcmn.CookieManager.markHotspotComplete) {
          Mcmn.CookieManager.markHotspotComplete(sectionType, 'hotspot');
          // Check completion after marking hotspot
          if (Mcmn.checkCompletion) {
            const viewedSections = new Set(Mcmn.CookieManager.getViewedSections());
            Mcmn.checkCompletion(viewedSections);
          }
        }

        // Don't start new drag if already dragging
        if (dragElement) {
          cancelDrag(); // Cancel existing drag first
        }

        currentGrassIndex = index;

        // Create drag element from grass-snippet
        dragElement = createDragGrass();
        if (!dragElement) {
          currentGrassIndex = null;
          return;
        }
        
        // Position drag element at cursor - instant (using stored original bbox)
        if (!grassSnippetOriginalBbox) {
          currentGrassIndex = null;
          return;
        }
        
        const svgPoint = screenToSVG(coords.clientX, coords.clientY);

        // Center the grass-snippet at cursor (like ornaments)
        const centerX = svgPoint.x - (grassSnippetOriginalBbox.width / 2);
        const centerY = svgPoint.y - (grassSnippetOriginalBbox.height / 2);
        
        dragElement.transform({ x: 0, y: 0, scale: 1 });
        dragElement.move(centerX, centerY);
        dragElement.scale(1);
        dragElement.opacity(1);
        dragElement.show();
        
        // Don't change grass appearance - leave it as-is

        // Show box-landing highlight with pulsing animation
        showBoxLandingHighlight();

        // Set up for dragging
        svgContainer.style.cursor = 'none'; // Hide cursor, grass-snippet is the cursor
        
        // Add event listeners for mouse and touch
        svgContainer.addEventListener('mousemove', handleMouseMove);
        svgContainer.addEventListener('touchmove', handleMouseMove, { passive: false });
        svgContainer.addEventListener('click', handleClick, true);
        svgContainer.addEventListener('touchend', handleClick, true);
        
        // Immediately update position
        handleMouseMove(e);
      };
      
      // Add both click and touch listeners to grass
      grass.addEventListener('click', grassClickHandler);
      grass.addEventListener('touchstart', grassClickHandler, { passive: false });
    });
    
    // Make message clickable to trigger grass grab (hotspot is hidden)
    const triggerGrassGrab = function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Find first grass element (allow any since continuous grabbing is enabled)
      let grassToGrab = null;
      let grassIndexToGrab = null;
      
      if (grassElements.length > 0) {
        grassToGrab = grassElements[0];
        grassIndexToGrab = 0;
      }
      
      if (grassToGrab) {
        // Simulate a click on the grass element
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          clientX: e.clientX || window.innerWidth / 2,
          clientY: e.clientY || window.innerHeight / 2
        });
        grassToGrab.dispatchEvent(clickEvent);
      }
    };
    
    if (placeTheGrass) {
      placeTheGrass.style.cursor = 'pointer';
      placeTheGrass.style.pointerEvents = 'auto';
      placeTheGrass.addEventListener('click', triggerGrassGrab);
      placeTheGrass.addEventListener('touchend', function(e) {
        e.preventDefault();
        e.stopPropagation();
        triggerGrassGrab(e);
      }, { passive: false });
    }

    // Restore positions
    restoreGrassPositions();
    
    // Check if download button should be shown (if grass already placed from previous session)
    function checkAndShowDownloadButton() {
      const downloadCards = svg.querySelector('#download-cards');
      if (!downloadCards) {
        return;
      }
      
      // Show the download button if at least one grass has been placed
      if (chapterState.placedGrass.size >= 1) {
        // Ensure download button is visible and interactive
        downloadCards.style.visibility = 'visible';
        downloadCards.style.display = 'block';
        downloadCards.style.pointerEvents = 'auto';
        gsap.set(downloadCards, { opacity: 1 });
        
        // Initialize the button handler if not already done
        if (!downloadCards.hasAttribute('data-initialized')) {
          initDownloadButton();
        }
      }
    }
    
    // Initialize download button
    function initDownloadButton() {
      const downloadCards = svg.querySelector('#download-cards');
      const downloadFlash = svg.querySelector('#get-recipes-flash');
      
      if (!downloadCards) {
        return;
      }
      
      // Mark as initialized to avoid duplicate handlers
      downloadCards.setAttribute('data-initialized', 'true');
      
      // Make button interactive
      downloadCards.style.cursor = 'pointer';
      downloadCards.style.pointerEvents = 'auto';
      
      // Flash animation is handled by CSS (pulse-flash keyframe)
      
      // Button click handler
      const downloadHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Check if newsletter has been submitted
        const hasNewsletter = Mcmn.CookieManager && Mcmn.CookieManager.hasSubmittedNewsletter();
        
        if (!hasNewsletter) {
          // Show newsletter popup
          
          // Try multiple methods to show popup
          setTimeout(function() {
            // Method 1: Use Drupal API if available
            if (typeof Drupal !== 'undefined' && Drupal.mcmnExperiencePopup && Drupal.mcmnExperiencePopup.show) {
              Drupal.mcmnExperiencePopup.show();
              return;
            }
            
            // Method 2: Dispatch custom event
            document.dispatchEvent(new CustomEvent('showMcmnPopup'));
            
            // Method 3: Direct DOM manipulation as fallback
            const newsletterPopup = document.querySelector('[data-mcmn-popup]');
            if (newsletterPopup) {
              newsletterPopup.classList.add('is-visible');
              document.body.style.overflow = 'hidden';
            }
          }, 100);
        } else {
          // Newsletter submitted, download PDF file
          downloadPostcardsPDF();
        }
      };
      
      downloadCards.addEventListener('click', downloadHandler);
      downloadCards.addEventListener('touchend', downloadHandler, { passive: false });
    }
    
    // Download the postcards PDF
    function downloadPostcardsPDF() {
      // Get base path for files (same logic as audio path)
      let basePath = '';
      if (typeof Drupal !== 'undefined' && Drupal.settings && Drupal.settings.basePath) {
        basePath = Drupal.settings.basePath;
      } else {
        const pathParts = window.location.pathname.split('/');
        const filtered = pathParts.filter(p => p);
        if (filtered.length > 0) {
          filtered.pop();
        }
        basePath = filtered.length > 0 ? '/' + filtered.join('/') : '';
      }
      basePath = basePath.replace(/\/$/, '');
      
      const pdfPath = basePath + '/themes/custom/discoverpr_v2_theme/images/mcmn-experience/MiCasaMiNavidadPostcards.pdf';
      
      // Create temporary anchor element to trigger download
      const link = document.createElement('a');
      link.href = pdfPath;
      link.download = 'MiCasaMiNavidadPostcards.pdf';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    
    // Check on load if button should be shown
    checkAndShowDownloadButton();
  }

  /**
   * Initialize coqui audio play/pause
   */
  function initCoquiAudio(svgContainer, svg, coqui, playButton, chapterState, sectionType) {
    let audio = null;
    
    // Get base path for files
    let basePath = '';
    if (typeof Drupal !== 'undefined' && Drupal.settings && Drupal.settings.basePath) {
      basePath = Drupal.settings.basePath;
    } else {
      const pathParts = window.location.pathname.split('/');
      const filtered = pathParts.filter(p => p);
      if (filtered.length > 0) {
        filtered.pop();
      }
      basePath = filtered.length > 0 ? '/' + filtered.join('/') : '';
    }
    const audioPath = basePath + 'themes/custom/discoverpr_v2_theme/audio/coqui.mp3';

    // Load audio
    audio = new Audio(audioPath);
    audio.loop = true;
    
    // Register this audio instance
    if (Mcmn.registerAudio) {
      Mcmn.registerAudio(sectionType, audio);
    }

    // Fallback for looping
    audio.addEventListener('ended', function() {
      audio.currentTime = 0;
      audio.play();
    });
    
    // Play/pause function
    function togglePlayPause() {
      if (audio.paused) {
        audio.play().catch(function(err) {
          // Audio play failed
        });
        chapterState.isPlaying = true;
      } else {
        audio.pause();
        chapterState.isPlaying = false;
      }
      if (Mcmn.saveChapterState) {
        Mcmn.saveChapterState(sectionType, chapterState);
      }
    }

    // Make coqui clickable
    coqui.style.cursor = 'pointer';
    coqui.style.pointerEvents = 'auto';

    // Add hover effect (grow a tiny bit and highlight)
    coqui.addEventListener('mouseenter', function() {
      gsap.to(coqui, {
        scale: 1.05, // Tiny bit of growth
        filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.6))', // Highlight effect
        duration: 0.2,
        ease: 'power2.out'
      });
    });

    coqui.addEventListener('mouseleave', function() {
      gsap.to(coqui, {
        scale: 1,
        filter: 'drop-shadow(0 0 0px rgba(255, 255, 255, 0))',
        duration: 0.2,
        ease: 'power2.out'
      });
    });

    // Click handler - play/pause (mobile touch support)
    const coquiClickHandler = function(e) {
      e.preventDefault();
      e.stopPropagation();
      togglePlayPause();
    };
    coqui.addEventListener('click', coquiClickHandler);
    coqui.addEventListener('touchend', coquiClickHandler, { passive: false });
    
    // Make play button clickable if it exists
    if (playButton) {
      playButton.style.cursor = 'pointer';
      playButton.style.pointerEvents = 'auto';
      
      // Add hover effect
      playButton.addEventListener('mouseenter', function() {
        gsap.to(playButton, {
          scale: 1.1,
          duration: 0.2,
          ease: 'power2.out',
          transformOrigin: 'center center'
        });
      });
      
      playButton.addEventListener('mouseleave', function() {
        gsap.to(playButton, {
          scale: 1,
          duration: 0.2,
          ease: 'power2.out'
        });
      });
      
      // Click handler - play/pause (mobile touch support)
      const playPauseHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        togglePlayPause();
      };
      playButton.addEventListener('click', playPauseHandler);
      playButton.addEventListener('touchend', playPauseHandler, { passive: false });
    }

    // Restore playback state
    if (chapterState.isPlaying) {
      audio.play().catch(function(err) {
        // Audio restore failed
      });
    }

    // Register cleanup handler for when chapter is offloaded
    if (Mcmn.registerChapterInstance) {
      Mcmn.registerChapterInstance(sectionType, {
        cleanup: function() {
          // Stop audio for this chapter
          if (Mcmn.stopAudioForSection) {
            Mcmn.stopAudioForSection(sectionType);
          }

          // Kill all GSAP animations
          gsap.killTweensOf(coqui);
          gsap.killTweensOf(playButton);
          gsap.killTweensOf(svg);
          gsap.killTweensOf(svgContainer);

          // Clean up all SVG content - remove children to free memory
          while (svg && svg.firstChild) {
            svg.removeChild(svg.firstChild);
          }

          // Mark SVG as unloaded AND remove it from container so it reloads on next visit
          if (svgContainer) {
            svgContainer.setAttribute('data-svg-loaded', 'false');
            // Also remove the SVG element itself so it gets reloaded fresh
            const svgElement = svgContainer.querySelector('svg');
            if (svgElement && svgElement.parentNode) {
              svgElement.parentNode.removeChild(svgElement);
            }
          }
        }
      });
    }
  }

  // Export functions to shared namespace
  Mcmn.initChapter4 = initChapter4;

})(Drupal, once);
